/* tslint:disable */
/* eslint-disable */
/**
 * crm-phone-agent
 * crm-phone-agent
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FacilityInfo
 */
export interface FacilityInfo {
    /**
     * Facility name
     * @type {string}
     * @memberof FacilityInfo
     */
    name: string;
    /**
     * Facility tax ID
     * @type {string}
     * @memberof FacilityInfo
     */
    tax_id: string;
    /**
     * Facility NPI number
     * @type {string}
     * @memberof FacilityInfo
     */
    npi: string;
    /**
     * Facility address
     * @type {string}
     * @memberof FacilityInfo
     */
    address: string;
    /**
     * Facility state code
     * @type {string}
     * @memberof FacilityInfo
     */
    state: string;
}

/**
 * Check if a given object implements the FacilityInfo interface.
 */
export function instanceOfFacilityInfo(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "tax_id" in value;
    isInstance = isInstance && "npi" in value;
    isInstance = isInstance && "address" in value;
    isInstance = isInstance && "state" in value;

    return isInstance;
}

export function FacilityInfoFromJSON(json: any): FacilityInfo {
    return FacilityInfoFromJSONTyped(json, false);
}

export function FacilityInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FacilityInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'tax_id': json['tax_id'],
        'npi': json['npi'],
        'address': json['address'],
        'state': json['state'],
    };
}

export function FacilityInfoToJSON(value?: FacilityInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'tax_id': value.tax_id,
        'npi': value.npi,
        'address': value.address,
        'state': value.state,
    };
}

